import type { ReactNode } from 'react';

export const symbol_filter_b_and_w: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M780-120H180q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18Zm-600-60h300v-342l300 342v-600H480v258L180-180Z"
		/>
	</svg>
);
